export const QUERY_COLOR = 'color';
export const QUERY_STORAGE = 'storage';
export const QUERY_COND = 'cond';
export const QUERY_MONTHLY_PAYMENT_PERIOD = 'mp';
export const QUERY_BUNDLE_PRICE_ID = 'bp';

export const ALLOWED_MONTHLY_PAYMENT_PERIODS = ['1', '12', '24', '36'];
export const DEFAULT_MONTHLY_PAYMENT_PERIOD = '36';
export const DEFAULT_PLAN_ID = '12';
export const DEFAULT_PREPAID_NAME_IDENTIFIER = '10 GB';
export const DEFAULT_PREPAID_SALDO_IDENTIFIER = '100';

export const toQueryParamValue = (value?: string) => {
  if (!value) {
    return '';
  }

  return value
    .toLocaleLowerCase()
    .replaceAll(' ', '-')
    .replaceAll('å', 'a')
    .replaceAll('ä', 'a')
    .replaceAll('ö', 'o');
};
